import React from 'react';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { Card, CardContent, Box, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import { tracking } from '../../utils/tracking';

const useStyles = makeStyles()(theme => ({
  card: {
    borderRadius: 16,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: 280,
    position: 'relative',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)'
    }
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '16px 0px 0px 16px !important'
  },
  title: {
    fontWeight: 450,
    color: '#000',
    zIndex: 100
  },
  iconContainer: {
    alignSelf: 'flex-end',
    borderTopLeftRadius: '80%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const NewDashboardCardWithIconLarge = ({
  intl,
  history,
  title,
  subtitle,
  img,
  cardBackgroundColor,
  iconBackgroundColor,
  url,
  onClick,
  style = {},
  trackingEventName,
  useDefaultTracking = true
}) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const trackEvent = () => {
    if (trackingEventName) {
      tracking(trackingEventName, {
        Label: title,
        Subtitle: subtitle,
        Image: img,
        'Background Color': cardBackgroundColor,
        Target: url
      });
    }
  };

  return (
    <Card
      className={classes.card}
      elevation={0}
      onClick={() => {
        if (useDefaultTracking) trackEvent();
        if (onClick) {
          onClick();
        } else if (url) {
          history.push(url);
        }
      }}
      style={{ backgroundColor: cardBackgroundColor, ...style }}
    >
      <CardContent className={classes.content}>
        <Box style={{ display: 'flex', alignItems: 'baseline', marginBottom: isXsScreen ? 8 : -12 }}>
          <Typography className={classes.title} style={{ fontSize: isXsScreen ? 24 : intl.locale === 'en' ? 28 : 32 }}>
            {title}
          </Typography>
          <Typography
            className={classes.title}
            style={{ fontSize: isXsScreen ? 12 : 16, marginLeft: isXsScreen ? 6 : 10 }}
          >
            {subtitle}
          </Typography>
        </Box>
        <Box
          className={classes.iconContainer}
          style={{
            backgroundColor: iconBackgroundColor,
            padding: isXsScreen ? '12px 8px 8px 16px' : '20px 12px 12px 24px'
          }}
        >
          <img alt={title} src={img} width={isXsScreen ? 20 : 30} height={isXsScreen ? 28 : 42} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default injectIntl(withRouter(NewDashboardCardWithIconLarge));
